export enum VideoType {
  MP4 = 'video/mp4'
}
